import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WaterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"water"}/>
}
